import { render, staticRenderFns } from "./svip.vue?vue&type=template&id=d6b5b118&scoped=true"
import script from "./svip.vue?vue&type=script&lang=js"
export * from "./svip.vue?vue&type=script&lang=js"
import style0 from "./svip.vue?vue&type=style&index=0&id=d6b5b118&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b5b118",
  null
  
)

export default component.exports